export default __webpack_public_path__ + "static/media/CAL29250.4221ddae.jpg";